
import { layout } from '@/mixins/customLayout'
import components from '@/components'

export default {
  name: 'Carousel',
  components,
  mixins: [layout],
  props: {
    blok: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      width: null,
      height: 500,
      carousel: 0,
      show: false
    }
  },
  computed: {
    classes() {
      return this.constructClassObj(this.blok.custom_layout, this)
    },
    thumbnailHeight() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 50 * this.blok.aspect_ratio
      } else {
        return 75 * this.blok.aspect_ratio
      }
    }
  },
  watch: {
    width(newWidth) {
      this.getNewHeight(newWidth)
    }
  },
  mounted() {
    this.width = this.$refs[`carousel${this.blok._uid}`].offsetWidth
    this.show = true
  },
  methods: {
    getNewHeight(w) {
      this.height = w * this.blok.aspect_ratio
    },
    setIndex(index) {
      this.carousel = index
    }
  }
}
